import { render, staticRenderFns } from "./KefuGoodsDetail.vue?vue&type=template&id=2991360e&scoped=true"
import script from "./KefuGoodsDetail.vue?vue&type=script&lang=js"
export * from "./KefuGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./KefuGoodsDetail.vue?vue&type=style&index=0&id=2991360e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991360e",
  null
  
)

export default component.exports